/**
 * 던전 도메인 부트스트래퍼 (S3) — 던전 탭 (도전/소탕 + 도전권·리셋 카운트다운 표시) + api 기여.
 * featureFlags.dungeon 게이트는 runBootSequence isEnabled로 — 비활성 빌드(웹 live)에선 설치 자체가 생략.
 * 전투 흐름은 DungeonFlow(셸 — boot.dungeon 라우트), 결정은 DungeonController.
 */
import { DungeonTabView } from "../ui/DungeonTabView.js";
import { buildDungeonData } from "../ui/tabData.js";
import { DAILY_RESET_KEY_DUNGEON_TICKETS } from "../models/ModuleBrickSaveData.js";
import { viewTabHandle } from "@yjsgames/phaser-ui/tab-registry";
import type { DomainBootstrapper } from "./BootTypes.js";

export const dungeonBoot: DomainBootstrapper = {
  key: "dungeon",
  install(boot) {
    boot.tabs.registerLazy("dungeon", {
      mount: () => {
        const { tabContent } = boot.layout;
        const view = new DungeonTabView(boot.scene, tabContent.x, tabContent.y, tabContent.width, {
          onChallenge: () => boot.dungeon.challenge(),
          onSweep: () => boot.dungeon.sweep(),
        });
        return viewTabHandle(view, () =>
          view.update(
            buildDungeonData(boot.ctx.dungeon(), boot.dailyReset(), boot.dungeon.isActive()),
          ),
        );
      },
    });
    // 자정 리셋 — 도전권 충전 (boot 미설치 빌드에선 던전 자체가 없어 리셋도 비활성).
    boot.dailyResets.register(DAILY_RESET_KEY_DUNGEON_TICKETS, () => boot.ctx.dungeon().refill());
    // ⚠ api{challengeDungeon/sweepDungeon}는 셸(core)이 등록 — 본 boot은 featureFlags.dungeon
    // isEnabled 게이트로 미설치될 수 있어, 여기서 등록하면 비활성 빌드에서 api.build() 망라성 throw.
  },
};
